import { EIndicatorSide } from '../type';

interface IndicatorOptions {
  position: { x: number; y: number };
  label?: string;
  side?: EIndicatorSide;
}

export class IndicatorModel {
  private _wrapper: HTMLElement | null = null;
  private _label: HTMLElement | null = null;

  update({ position, label, side }: IndicatorOptions): void {
    if (!this._wrapper) return;

    if (label && this._label) {
      this._label.innerText = label;
    }
    if (side && this._label) {
      this._label.setAttribute('data-dir', side);
    }

    this._wrapper.style.transform = `translate(${position.x}px, ${position.y}px)`;
  }

  create() {
    if (this._wrapper) {
      this.dispose();
    }
    this._wrapper = document.createElement('div');
    this._wrapper.classList.add('indicator-wrapper');
    this._label = document.createElement('div');
    this._label.classList.add('indicator-label');
    this._wrapper.appendChild(this._label);
    document.body.appendChild(this._wrapper);
  }

  clear(): void {
    this.dispose();
  }

  dispose(): void {
    // 清理DOM元素
    if (this._wrapper && this._wrapper.parentNode) {
      this._wrapper.parentNode.removeChild(this._wrapper);
    }
  }
}
